import { useCallback } from 'react';

type MessageType = 
  | 'app-error' 
  | 'app-not-get-token' 
  | 'app-success-add'
  | 'app-failed-any'
  | 'app-update-shipping' 
  | '';

export const useEmitMessage = (
  behavior: 'keep' | 'fade' = 'fade',
  type: 'toaster' | 'modal' = 'toaster',
) => {

  const emitMessage = useCallback((message: MessageType) => {
    if (message) window.parent.postMessage({ action: 'message', message, behavior, type }, '*'); 
  }, [behavior, type]);

  return emitMessage;
};
